import { useNavigate } from 'react-router-dom';
import { csManager } from '@shared/utils';
import { Suspense } from '@core/suspense';
import { useAuth } from '@shared/hooks';
import { useEffect } from 'react';

const ImpersonateCallback = () => {
  const navigate = useNavigate();
  const { impersonate } = useAuth();

  useEffect(() => {
    const processImpersonation = async () => {
      try {
        // Token is in the cookie storage
        const impersonatedToken = csManager.get('IMPERSONATED_TOKEN');

        if (!impersonatedToken) {
          throw new Error('No impersonated token found');
        }

        // Use our service to create and store the user session
        await impersonate(impersonatedToken);

        // remove token from cookie storage to allow multiple impersonations in the same domain
        csManager.remove('IMPERSONATED_TOKEN');

        // Use a full page reload instead of React Router navigation
        // This ensures all state is completely reset and the new user session is properly recognized
        window.location.href = import.meta.env.VITE_BASE_PATH;
      } catch (error) {
        console.error('Failed to process impersonation:', error);
      }
    };

    processImpersonation();
  }, [navigate, impersonate]);

  return <Suspense />;
};

export default ImpersonateCallback;
